import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.isEnabled}}\n  {{yield}}\n{{/if}}", {
  moduleName: "@dashboard/shared-ui/components/is-feature-flag-enabled.hbs"
});